import { type Leaderboard } from "@client/content/modules/Leaderboard/types";
import Icon from "@client/controls/Icon/component";
import { IconType } from "@client/types";
import { useI18n } from "@common/hooks/i18n";
import classnames from "classnames";
import * as React from "react";
import ProfileImage from "../../ProfileImage/component";

export type ItemLinkType = "none" | "vote" | "voteLink";
export type MapProps = {
  isMobile: boolean;
  item: Leaderboard.Item;
  current?: Leaderboard.Item | null;
  referring?: Leaderboard.Item | null;
};

export type ActionProps = {
  onClick?: (item: Leaderboard.Item) => void;
};

type Props = ActionProps & MapProps;
export default ({ isMobile, item, onClick, current, referring }: Props) => {
  const i18n = useI18n();

  const linkType = React.useMemo(
    () => (current?.userId === item.userId ? "voteLink" : "vote"),
    [current?.userId, item.userId]
  );

  const className = React.useMemo(
    () =>
      classnames({
        clickable: true,
        highlight: current?.userId === item.userId || referring?.userId === item.userId
      }),
    [current?.userId, item.userId]
  );

  return (
    <tr className={classnames("item", className)} onClick={() => onClick && onClick(item)}>
      <td className="position">
        <div className="content">
          {item.position}{" "}
          <span className={classnames("movement", { down: (item.movement ?? 0) < 0, up: (item.movement ?? 0) >= 0 })}>
            {Math.abs(item.movement ?? 0)}
          </span>
        </div>
      </td>
      <td className="name">
        <div className="content">
          <ProfileImage item={item} size={50} />{" "}
          <span>
            {item.firstName} {item.lastName}
          </span>
        </div>
      </td>
      {!isMobile && <td className="country">{item.countryName}</td>}
      <td className="score">
        <div className="content">{item.score}</div>
      </td>
      {!isMobile && (
        <td>
          {item.type === "launch" && linkType === "vote" && (
            <a className="link">
              <Icon iconClassName="far fa-thumbs-up" /> {i18n.vote}
            </a>
          )}
          {item.type === "launch" && linkType === "voteLink" && (
            <a className="link">
              <Icon iconClassName={IconType.Link} /> {i18n.voteLink}
            </a>
          )}
        </td>
      )}
    </tr>
  );
};
